





























































import { Component, Vue } from 'vue-property-decorator';
import CandidateForgotPasswordAccountDetails from './CandidateForgotPasswordAccountDetails.vue';
import CandidateForgotPasswordSecurityCode from './CandidateForgotPasswordSecurityCode.vue';
import CandidateForgotPasswordReset from './CandidateForgotPasswordReset.vue';
@Component({
  components: {
    CandidateForgotPasswordAccountDetails,
    CandidateForgotPasswordSecurityCode,
    CandidateForgotPasswordReset,
  },
})
export default class CandidateSignUp extends Vue {
  step = 1;

  beforeDestroy() {
    this.$store.commit('Auth/CLEAR_GUEST_STATE');
  }
}
